import { useEffect } from "react";
import {
  PostHogProvider as BasePostHogProvider,
  usePostHog,
} from "posthog-js/react";

import PropTypes from "prop-types";

// PostHog docs: https://posthog.com/docs/libraries/react
const options = {
  api_host: window.HA_CONF.POSTHOG.HOST,
};

export const PostHogProvider = ({ children, user = null }) => {
  const posthog = usePostHog();

  useEffect(() => {
    if (user.token) {
      posthog?.identify(user.token, {
        email: user.email,
        first_name: user.firstName,
        last_name: user.lastName,
        employer_id: user.employer?.id,
        employer_name: user.employer?.name,
        impersonator_id: window.HA_CONF.IMPERSONATOR_ID,
      });
    }
  }, [
    posthog,
    user.token,
    user.email,
    user.firstName,
    user.lastName,
    user.employer?.id,
    user.employer?.name,
  ]);

  return (
    <BasePostHogProvider
      apiKey={window.HA_CONF.POSTHOG.API_KEY}
      options={options}
    >
      {children}
    </BasePostHogProvider>
  );
};

PostHogProvider.propTypes = {
  children: PropTypes.element.isRequired,
  user: PropTypes.shape({
    token: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    employer: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  }),
};
